import type { FormatterArgs } from '@/services/types/formatter';

export default ({ data, key }: FormatterArgs) => {
  let text = '';

  if (data[key] === 1) {
    text = '✅';
  } else if (data[key] === 0) {
    text = '❌';
  }

  return { kind: 'text-block', text };
};
